import React from 'react';
import { Box } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import useResponsive from 'hooks/useResponsive';
import { HighlightVideo } from './HighlightVideo';
import LatestCourses from './LatestCourses';
import LatestNews from './LatestNews';
import LatestNewsNext from './LatestNewsNext';
import LocalNewsPaper from './LocalNewsPaper';
import QuickLinks from './QuickLinks';
import SponsorRow from './SponsorRow';
import { LiveVideo } from './LiveVideo';

const Home = () => {
  usePageTitle();
  const { isMobile } = useResponsive();
  return (
    <>
      {/* {!isMobile && (
        <ImageCarousel images={[image1, image2, image3, image4, image5]} />
      )} */}
      <LiveVideo />
      <SponsorRow />
      <Box pad="large" align="center" justify="center">
        <QuickLinks />
      </Box>
      <Box
        pad="large"
        align="center"
        justify="center"
        direction={isMobile ? 'column' : 'row'}
      >
        <LocalNewsPaper />
        <HighlightVideo />
      </Box>
      <LatestNews />
      <LatestNewsNext />
      <LatestCourses />
    </>
  );
};

export default Home;
